module.exports = __webpack_public_path__ + "static/media/coupon-mob.34a5f3db.svg";